import * as B from '@blueprintjs/core';
import React from 'react';

const PointIcon: React.FunctionComponent<{
  color?: string;
  size?: number;
}> = ({color, size = 16}) => (
  <B.Icon
    style={{cursor: 'pointer'}}
    icon={
      <span className="bp5-icon">
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="7" fill={color} fillOpacity={0.5} stroke={color} strokeWidth="2" />
        </svg>
      </span>
    }
  />
);

export default PointIcon;
